import { ReactNode, useState } from 'react';
import { useTheme } from '../../lib/design-system';

interface CollapsibleProps {
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
  trailing?: ReactNode;
}

const ChevronIcon = ({ open }: { open: boolean }) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    style={{ transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.18s' }}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export default function Collapsible({
  title,
  defaultOpen = false,
  children,
  trailing,
}: CollapsibleProps) {
  const { theme } = useTheme();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className="rounded-2xl overflow-hidden"
      style={{
        backgroundColor: theme.surface,
        border: `1px solid ${theme.border}`,
        boxShadow: theme.shadow,
      }}
    >
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-3 px-4 py-3 text-left"
        aria-expanded={open}
      >
        <span className="font-display text-[15px] font-black flex-1" style={{ color: theme.text }}>
          {title}
        </span>
        {trailing}
        <span style={{ color: theme.textMuted }}>
          <ChevronIcon open={open} />
        </span>
      </button>
      {open && (
        <div className="px-4 pb-4" style={{ borderTop: `1px solid ${theme.border}` }}>
          <div className="pt-3">{children}</div>
        </div>
      )}
    </div>
  );
}
